import script from "./ViewAllAdvice.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllAdvice.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__